import { BusinessRole } from "fe-shared/src/types/domain";
import { InfoPlateVariant } from "fe-shared/src/components";
import { ApiError } from "fe-shared/src/types/common";

interface DefaultData {
  [key: string]: any;
}

export enum RequestStatus {
  Submitted = "Submitted",
  InReview = "Reviewing",
  Approved = "Approved",
  Rejected = "Rejected",
}

export enum RequestType {
  GiantTiresPickup = "GiantTiresPickup",
}

export interface RequestTiresData {
  quantity: number;
  make?: string;
  model?: string;
  dimensions?: string;
}

export interface RequestFormData extends DefaultData {
  largeTireDetailsSelected: boolean;
  largeTireDetails?: RequestTiresData | null;
  giantTireDetailsSelected: boolean;
  giantTireDetails?: RequestTiresData | null;
  collectorName: string;
  collectorId: string;
  pickUpDateFrom: string | null;
  pickUpDateTo: string | null;
  processorName: string;
  processorId: string;
}

export interface HaulerRequestFormData extends DefaultData {
  haulerName: string;
  haulerId: string;
}

export interface StaffRequestFormData
  extends HaulerRequestFormData,
    RequestFormData {}

export interface CreateRequestData extends DefaultData {
  largeTireDetails?: RequestTiresData | null;
  giantTireDetails?: RequestTiresData | null;
  collectorId: string;
  haulerId: number;
  pickUpDateFrom: string | null;
  pickUpDateTo: string | null;
  processorId: string;
}

export interface RequestDataResponse extends CreateRequestData, DefaultData {
  largeTireDetailsSelected: boolean;
  giantTireDetailsSelected: boolean;
  haulerName: string;
  collectorName: string;
  processorName: string;
  status: RequestStatus;
  isCreatedByStaff?: boolean;
}

interface ParticipantData {
  displayName: string;
  businessRoleCode: string;
  companyId: number;
}

export interface RequestDataResponseRaw extends DefaultData {
  assignedTo?: number;
  assignedToDisplayName?: string;
  submittedDate: string;
  requestId: number;
  largeTireDetails: RequestTiresData;
  giantTireDetails: RequestTiresData;
  collector: ParticipantData;
  collectorId: string;
  collectorRegNumber: number;
  hauler: ParticipantData;
  haulerId: number;
  pickupDateFrom: string;
  pickupDateTo: string;
  processor: ParticipantData;
  processorId: string;
  processorRegNumber: number;
  statusCode: RequestStatus;
  type: RequestType;
  reasonOfRejected?: string;
  isCreatedByStaff?: boolean;
}

export interface ExternalTires {
  amount: number;
  code: string;
}

export interface ExternalRequest {
  requestId: number;
  pickUpDateFrom: string;
  pickUpDateTo: string;
  status: RequestStatus | null;
  submittedOn: string;
  type: string;
  materials: ExternalTires[];
}

export interface InternalRequest extends DefaultData {
  requestId: number | null;
  type: string;
  pickUpDateFrom: string;
  pickUpDateTo: string;
  submittedOn: string;
  status: RequestStatus | null;
  materials: ExternalTires[];
}

export interface RequestsResponse<T> {
  total: number;
  requests: T[];
}

export type RequestStatusesConfigMap = {
  [key in RequestStatus]?: InfoPlateVariant;
};

export type RequestTypesConfigMap = {
  [key in RequestType]?: InfoPlateVariant;
};

export const REQUESTS_STATUS_CONFIG_MAP: RequestStatusesConfigMap = {
  [RequestStatus.Submitted]: "success",
  [RequestStatus.InReview]: "warning",
  [RequestStatus.Approved]: "success-dark",
  [RequestStatus.Rejected]: "error",
};

export const REQUESTS_TYPE_CONFIG_MAP: RequestTypesConfigMap = {
  [RequestType.GiantTiresPickup]: "neutral",
};

export interface DataGridFiltersParams {
  propertyName: string;
  values: string;
}

export interface DataGridOptionsParams {
  isAscending: boolean;
  propertyName: string;
}

export interface DataGridRequestParams {
  sortingBy: DataGridOptionsParams;
  filteringParameters: DataGridFiltersParams[];
}

export interface RequestApiError extends ApiError {
  additionalInfo?: {
    businessRoleCode: BusinessRole;
  };
}
